import PropTypes from "prop-types";

export default function Toggle({ on, onClick, disabled, ariaLabel, id }) {
  return (
    <button
      id={id}
      type="button"
      className={`rec-switch${on ? " on" : ""}`}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={on}
      aria-label={ariaLabel}
      style={disabled ? { opacity: 0.5, cursor: "default" } : undefined}
    />
  );
}

Toggle.propTypes = {
  on: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  id: PropTypes.string,
};

Toggle.defaultProps = {
  on: false,
  onClick: undefined,
  disabled: false,
  ariaLabel: undefined,
  id: undefined,
};
